import App from './App.vue'
import VueRouter from 'vue-router'
import {routes} from "@/RouteConfig";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueClipboard from 'vue-clipboard2';
import Vue from "vue";
import 'swiper/css/swiper.css'
Vue.use(VueClipboard)
Vue.use(ElementUI);
/// 全局注册
Vue.use(VueRouter);
//实例化VueRouter对象

const router = new VueRouter({
  // history模式，去除URL中#
  // mode: 'history',
  routes,// (缩写) 相当于 routes: routes
  // 解决路由跳转后，不显示在首行
  scrollBehavior() {
    return {x: 0, y: 0};
  }

})
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
